// This hook dispatches GA event when the user scrolls the page
// until the required section becomes visible in the viewport
// It triggers GA event dispatching only once - on the first view of the section

import { useEffect, useRef } from 'react';
import throttle from 'lodash/throttle';
import { isElementVisibleInViewport } from 'core/utils/helpers/isElementVisibleInViewport';

export const useTriggerSectionIsViewedGaEvent = (sectionRef, dispatchTriggerSectionIsViewed, isSectionShown) => {
  const wasSectionVisibleInViewportBefore = useRef(false);
  const throttledHandleGaEvents = throttle(handleGaEvents, 500);

  useEffect(() => {
    window.addEventListener('scroll', throttledHandleGaEvents);

    return () => {
      window.removeEventListener('scroll', throttledHandleGaEvents);
    };
  }, [isSectionShown]);

  useEffect(() => {
    // Trigger GA event if section is visible after page load, without needing to scroll to it
    setTimeout(() => { handleGaEvents(); }, 1000);
  }, [isSectionShown]);

  function handleGaEvents() {
    if (wasSectionVisibleInViewportBefore.current) { return; }

    const isSectionVisibleInViewport = isElementVisibleInViewport(sectionRef.current, 0);

    if (isSectionVisibleInViewport) {
      dispatchTriggerSectionIsViewed();
      window.removeEventListener('scroll', throttledHandleGaEvents);
      wasSectionVisibleInViewportBefore.current = true;
    }
  }
};
